/*@ngInject*/
const UIScrollDetectionDirective = function ($window, $timeout) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let element = $($elm),
            target = element,
            window = $($window),
            handleDomChange,
            currentResizeTimeout;

        if ($attrs.uiScrollDetectionTarget) {
            target = $($attrs.uiScrollDetectionTarget);
        }

        function checkForScrollBars() {
            element.off('DOMSubtreeModified', handleDomChange);
            window.off('resize.uiScrollDetection', handleResize);
            let isScrolling = element[0].scrollHeight > element[0].clientHeight,
                isScrollbarPresent = element[0].clientWidth < element[0].offsetWidth;

            if (isScrolling && isScrollbarPresent) {
                target.addClass('scrolling');
            }
            else {
                target.removeClass('scrolling');
            }
            element.on('DOMSubtreeModified', handleDomChange);
            window.on('resize.uiScrollDetection', handleResize);
        }

        function handleResize() {
            $timeout.cancel(currentResizeTimeout);
            currentResizeTimeout = $timeout(function () {
                requestAnimationFrame(checkForScrollBars);
            }, 500);
        }

        handleDomChange = _.debounce(function () {
            requestAnimationFrame(checkForScrollBars);
        }, 500);

        element.on('DOMSubtreeModified', handleDomChange);
        window.on('resize.uiScrollDetection', handleResize);

        $scope.$on('$destroy', function () {
            element.off('DOMSubtreeModified', handleDomChange);
            window.off('resize.uiScrollDetection', handleResize);
            $timeout.cancel(currentResizeTimeout);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiScrollDetection', UIScrollDetectionDirective);
